// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__LCG6r","modal__close":"Modal_modal__close__OCK-r","modal__text":"Modal_modal__text__MUbP2","modal__confirm":"Modal_modal__confirm__YSw8t"};